module.exports = __webpack_public_path__ + "static/media/ordering-provider.f1a1eb66.png";